import { render, staticRenderFns } from "./rewardPickOneEdit_bak.vue?vue&type=template&id=8e5a5868&scoped=true&"
import script from "./rewardPickOneEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardPickOneEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5a5868",
  null
  
)

export default component.exports